import { render, staticRenderFns } from "./backoffice-comorbidades.vue?vue&type=template&id=c0641bfa"
import script from "./backoffice-comorbidades.vue?vue&type=script&lang=ts"
export * from "./backoffice-comorbidades.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports